import fetchAdminInfoBuilder from '@/usecases/admins/fetchAdminInfo';
import fetchLastUploadedDocumentsBuilder from '@/usecases/admins/fetchLastUploadedDocuments';
import adminRepository from '@/repositories/admins/';

export default {
  fetchAdminInfo: fetchAdminInfoBuilder({ adminRepository }),
  fetchLastUploadedDocuments: fetchLastUploadedDocumentsBuilder({ adminRepository }),
};
